/**
 * The campaign tag a page view is recorded with (register: from-tags-were-never-recorded-1018).
 *
 * 🚨 WHY. Every email and in-site CTA tags its links with `?from=<source>` (trial-recap, payer-howto,
 * welcome-scanner, dunning ...), but the tracker stored only `window.location.pathname` and
 * `utm_campaign`, so every `from` tag was thrown away. Measured 2026-10-18: 465,190 page views in 30 days
 * had a NULL utm_campaign and 2 had one; email-attributed sessions were 17 in 30 days. Which email or
 * button brings people back was unmeasurable.
 *
 * RULE: an explicit utm_campaign wins, unchanged (paid-cohort-read.ts keys on exact campaign names). Else a
 * `from` value is recorded as `from:<value>`. The prefix means it can never collide with a real campaign.
 * Sanitised to [A-Za-z0-9_.-] and capped, so a crafted URL cannot write junk into analytics.
 */
export function campaignTag(params: URLSearchParams): string | null {
  const utm = params.get('utm_campaign')
  if (utm) return utm
  const from = (params.get('from') || '').replace(/[^A-Za-z0-9_.-]/g, '').slice(0, 60)
  return from ? `from:${from}` : null
}
